module.exports = __webpack_public_path__ + "static/img/empty.5a7fe3a0.svg";